export const enum EOrganizations {
  GXO = 'ND'
}
